<app-online-training-banner></app-online-training-banner>

<app-online-training-courses></app-online-training-courses>

<div class="features-area pt-100 pb-70">
    <app-features-style-two></app-features-style-two>
</div>

<app-online-training-about></app-online-training-about>

<div class="section-title mb-4 mt-2">
    <h2>Champion School at a Glance</h2>
</div>

<div class="bg-fffaf3">
    <app-funfacts-style-one></app-funfacts-style-one>
</div>

<div class="advisor-area bg-f9f9f9 pt-100">
    <app-instructor-style-two></app-instructor-style-two>
</div>

<div class="premium-access-area bg-f9f9f9 ptb-100">
    <app-premium-access></app-premium-access>
    <div class="shape3"><img src="images/shape3.png" alt="image"></div>
    <div class="shape4"><img src="images/shape4.png" alt="image"></div>
    <div class="shape8"><img src="images/shape7.png" alt="image"></div>
</div>